import { useEffect } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { useSelector } from 'statux'

import DashboardContent from './DashboardContent/DashboardContent'
import DashboardEbpc from './DashboardEbpc/DashboardEbpc'
import DashboardEbpcApplication
    from './DashboardEbpcApplication/DashboardEbpcApplication'
import DashboardEbpcApplicationReview
    from './DashboardEbpcApplicationReview/DashboardEbpcApplicationReview'
import DashboardEbpcAssignments
    from './DashboardEbpcAssignments/DashboardEbpcAssignments'
import DashboardEbpcJudgeOrientation
    from './DashboardEbpcJudgeOrientation/DashboardEbpcJudgeOrientation'
import DashboardHome from './DashboardHome/DashboardHome'
import DashboardHub from './DashboardHub/DashboardHub'
import DashboardProfile from './DashboardProfile/DashboardProfile'
import DashboardSettings from './DashboardSettings/DashboardSettings'
import DashboardSettingsAdvancedMembers from
    './DashboardSettingsAdvancedMembers/DashboardSettingsAdvancedMembers'

import authProvider from '../../utils/auth-provider'

export default function Dashboard (props = {
    data: null
}) {
    const components = {
        DashboardContent,
        DashboardEbpc,
        DashboardEbpcApplication,
        DashboardEbpcApplicationReview,
        DashboardEbpcAssignments,
        DashboardEbpcJudgeOrientation,
        DashboardHome,
        DashboardHub,
        DashboardProfile,
        DashboardSettings,
        DashboardSettingsAdvancedMembers
    }

    const route = useSelector('routes')
        .filter(obj => obj.type === 'Dashboard')[0] || {}

    const defaultPath = (route.path[0] || '')
        .replace(/\/$/, '')

    const routes = (route.routes || [])
        .map(obj => {
            const { type, ...props } = obj

            return ({
                Component: components[type],
                ...props
            })
        })
        .filter(obj => obj.Component
            && (obj.path || []).length)

    const routesExact = routes
        .filter(obj => obj.exact)

    const routesDynamic = routes
        .filter(obj => !obj.exact)

    const getRoutesPathsArray = (arr) => arr
        .map(obj => obj.path)
        .reduce((acc, curr) => acc.concat(curr), [])

    const routesConfig = [{
        exact: true,
        path: getRoutesPathsArray(routesExact),
        routes: routesExact
    }, {
        exact: false,
        path: getRoutesPathsArray(routesDynamic),
        routes: routesDynamic
    }]

    useEffect(() => {
        const root = document.getElementById('root')

        const content = document.getElementById('content')

        if (content.innerHTML)
            return root.style.height
                && root.removeAttribute('style')

        root.setAttribute('style',
            'height: calc(100vh + var(--sticky-nav-offset));')

        root.style.overflow = 'hidden'

        const contentInterval = setInterval(() => {
            if (!content.innerHTML)
                return

            clearInterval(contentInterval)

            root.style.overflow = ''
            root.style.height = ''
        }, 1)
    }, [])

    return (
        <Switch>
            {!authProvider.isSessionExpired()
                && routesConfig
                    .filter(obj => obj.routes.length
                        && obj.path.length)
                    .map((obj, idx) => {
                        const { routes, ...routeProps } = obj

                        return (
                            <Route
                                key={`dashboard-route-${idx}`}
                                {...routeProps}
                            >
                                <Switch>
                                    {routes
                                        .map((obj, _idx) => {
                                            const {
                                                Component,
                                                dataPathSuffix,
                                                ...routeProps
                                            } = obj

                                            return (
                                                <Route
                                                    key={`dashboard-route-${
                                                        idx}-${
                                                        _idx}`}
                                                    {...routeProps}
                                                >
                                                    <Component
                                                        {...(props.data || [])[0]}
                                                    />
                                                </Route>
                                            )
                                        })}
                                </Switch>
                            </Route>
                        )
                    })}
            {!authProvider.isSessionExpired()
                && (
                    <Route path="*">
                        <Redirect to={defaultPath} />
                    </Route>)}
        </Switch>
    )
}
